export class TextArea {
    format?:string;
    showLabel?:boolean;
    validatorMessage?: boolean;
    tooltipMessage?: boolean;
    submitted?: boolean;
    validatorAlert?: boolean;
}